/**
 * Mainbeauty — khu vực tài khoản trên header.
 *
 *   · Chưa đăng nhập: [data-pi-login-open] mở popup đăng nhập (dựng ở footer.php).
 *   · Đã đăng nhập:   icon tài khoản bật/tắt droplist "Khóa học của tôi · Đăng xuất".
 *
 * Việc GỬI form nằm ở plugin (mainbt-lms/assets/js/pi-lms-login.js) — cùng ranh giới với
 * popup tư vấn: theme lo hiệu ứng, plugin lo hành vi. Tắt plugin thì form POST thẳng sang
 * wp-login.php, popup vẫn mở ra bình thường.
 */
import { bindPopupClose, closeAutoPopup, focusFirstField } from "./mainbt-popup-form.js";

function initLoginPopup() {
  const popup = document.querySelector("[data-pi-login]");
  if (!popup) return;

  const isOpen = () => popup.classList.contains("is-open");

  const open = () => {
    // Popup tự động phải tắt: chồng lớp phủ cùng z-index, và một phím Escape đóng cả hai.
    closeAutoPopup();
    popup.classList.add("is-open");
    document.body.classList.add("pi-noscroll");
    focusFirstField(popup);
  };

  const close = () => {
    popup.classList.remove("is-open");
    document.body.classList.remove("pi-noscroll");
  };

  document.addEventListener("click", (e) => {
    // Popup đăng nhập có link "Nhận tư vấn để ghi danh". Không đóng trước thì hai lớp phủ
    // chồng lên nhau và đóng cái trên chỉ để lộ cái dưới — trông như bấm đóng không ăn.
    //
    // 🚨 Chỉ gỡ is-open, KHÔNG gọi close(): mainbt-consult.js đăng ký listener trước file
    // này (thứ tự import trong main.js) nên popup tư vấn đã mở xong và đã đặt .pi-noscroll
    // trước khi tới đây. close() sẽ gỡ đúng cái khoá cuộn mà nó vừa đặt, và nền trang cuộn
    // được sau lưng một popup đang mở.
    if (isOpen() && e.target.closest("[data-pi-consult-open]")) {
      popup.classList.remove("is-open");
      return;
    }

    const trigger = e.target.closest("[data-pi-login-open]");
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  bindPopupClose(popup, "[data-pi-login-box]", "[data-pi-login-close]", close);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen()) close();
  });

  // Link "Đăng nhập ngay" trong thư ghi danh về thẳng trang khóa rồi bật popup ở đây.
  // 🚨 Tên tham số trùng PiLmsAuthService::LOGIN_PARAM — đổi một bên là link trong thư thành trang câm.
  const params = new URLSearchParams(window.location.search);
  if (params.has("dang-nhap")) {
    open();

    // Gỡ tham số khỏi URL: để lại thì F5 hay bấm Back là popup bật lên lần nữa sau khi đã đăng nhập.
    params.delete("dang-nhap");
    const query = params.toString();
    window.history.replaceState(
      {},
      "",
      window.location.pathname + (query ? "?" + query : "") + window.location.hash
    );
  }
}

function initAccountMenu() {
  const wrap = document.querySelector("[data-pi-account]");
  if (!wrap) return;

  const toggle = wrap.querySelector("[data-pi-account-toggle]");
  const menu = wrap.querySelector("[data-pi-account-menu]");
  if (!toggle || !menu) return; // khách chưa đăng nhập: chỉ có link mở popup, không có droplist

  const setOpen = (state) => {
    menu.hidden = !state;
    toggle.setAttribute("aria-expanded", state ? "true" : "false");
  };

  toggle.addEventListener("click", () => setOpen(menu.hidden));

  // Bấm ra ngoài / Escape thì đóng — droplist neo vào header sticky nên nó theo người dùng
  // suốt trang, để mở là nó che nội dung ở mọi lần cuộn.
  document.addEventListener("click", (e) => {
    if (!menu.hidden && !wrap.contains(e.target)) setOpen(false);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !menu.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initLoginPopup();
  initAccountMenu();
});
